// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller
/* eslint-disable */

import { application } from "../application"
import "../shared"

import AdditionController from './addition_controller.js'
application.register('addition', AdditionController)

import AjaxController from './ajax_controller.js'
application.register('ajax', AjaxController)

import AlertsController from './alerts_controller.js'
application.register('alerts', AlertsController)

import AnimationController from './animation_controller.js'
application.register('animation', AnimationController)

import AsyncRenderController from './async_render_controller.js'
application.register('async-render', AsyncRenderController)

import AvatarPhotoEditorController from './avatar_photo_editor_controller.js'
application.register('avatar-photo-editor', AvatarPhotoEditorController)

import BinderController from './binder_controller.js'
application.register('binder', BinderController)

import BlendNavigationController from './blend/navigation_controller.js'
application.register('blend--navigation', BlendNavigationController)

import CarouselController from './carousel_controller.js'
application.register('carousel', CarouselController)

import ClipboardController from './clipboard_controller.js'
application.register('clipboard', ClipboardController)

import ColorPickerController from './color_picker_controller.js'
application.register('color-picker', ColorPickerController)

import ConfirmationController from './confirmation_controller.js'
application.register('confirmation', ConfirmationController)

import ConsumptionController from './consumption_controller.js'
application.register('consumption', ConsumptionController)

import CountdownController from './countdown_controller.js'
application.register('countdown', CountdownController)

import DirectUploadController from './direct_upload_controller.js'
application.register('direct-upload', DirectUploadController)

import DynaformCalendarController from './dynaform/calendar_controller.js'
application.register('dynaform--calendar', DynaformCalendarController)

import DynaformDisplayController from './dynaform/display_controller.js'
application.register('dynaform--display', DynaformDisplayController)

import DynaformNavigationController from './dynaform/navigation_controller.js'
application.register('dynaform--navigation', DynaformNavigationController)

import DynaformParentController from './dynaform/parent_controller.js'
application.register('dynaform--parent', DynaformParentController)

import DynaformProgressController from './dynaform/progress_controller.js'
application.register('dynaform--progress', DynaformProgressController)

import DynaformTimeController from './dynaform/time_controller.js'
application.register('dynaform--time', DynaformTimeController)

import DynaformValidationController from './dynaform/validation_controller.js'
application.register('dynaform--validation', DynaformValidationController)

import DynaformController from './dynaform_controller.js'
application.register('dynaform', DynaformController)

import EnablerController from './enabler_controller.js'
application.register('enabler', EnablerController)

import ExpandableController from './expandable_controller.js'
application.register('expandable', ExpandableController)

import FiltersController from './filters_controller.js'
application.register('filters', FiltersController)

import FlashController from './flash_controller.js'
application.register('flash', FlashController)

import FormController from './form_controller.js'
application.register('form', FormController)

import FullPhotoEditorController from './full_photo_editor_controller.js'
application.register('full-photo-editor', FullPhotoEditorController)

import GiftRegistryController from './gift_registry_controller.js'
application.register('gift-registry', GiftRegistryController)

import ImagePreviewLoaderController from './image_preview_loader_controller.js'
application.register('image-preview-loader', ImagePreviewLoaderController)

import ImagerController from './imager_controller.js'
application.register('imager', ImagerController)

import IntersectorController from './intersector_controller.js'
application.register('intersector', IntersectorController)

import ModalController from './modal_controller.js'
application.register('modal', ModalController)

import ModelsCartController from './models/cart_controller.js'
application.register('models--cart', ModelsCartController)

import ModelsCartItemController from './models/cart_item_controller.js'
application.register('models--cart-item', ModelsCartItemController)

import ModelsRsvpController from './models/rsvp_controller.js'
application.register('models--rsvp', ModelsRsvpController)

import MozController from './moz_controller.js'
application.register('moz', MozController)

import MultiplicationController from './multiplication_controller.js'
application.register('multiplication', MultiplicationController)

import NavigationController from './navigation_controller.js'
application.register('navigation', NavigationController)

import PagarmeController from './pagarme_controller.js'
application.register('pagarme', PagarmeController)

import TunaController from './tuna_controller.js'
application.register('tuna', TunaController)

import PaypalController from './paypal_controller.js'
application.register('paypal', PaypalController)

import PhotoEditorController from './photo_editor_controller.js'
application.register('photo-editor', PhotoEditorController)

import ReceiptsController from './receipts_controller.js'
application.register('receipts', ReceiptsController)

import RemoteAnchorController from './remote_anchor_controller.js'
application.register('remote-anchor', RemoteAnchorController)

import RemoteFormController from './remote_form_controller.js'
application.register('remote-form', RemoteFormController)

import RemoteInputController from './remote_input_controller.js'
application.register('remote-input', RemoteInputController)

import RemoteModalController from './remote_modal_controller.js'
application.register('remote-modal', RemoteModalController)

import SendMessageController from './send_message_controller.js'
application.register('send-message', SendMessageController)

import SetoutEditorController from './setout/editor_controller.js'
application.register('setout--editor', SetoutEditorController)

import SetoutFragmentController from './setout/fragment_controller.js'
application.register('setout--fragment', SetoutFragmentController)

import SetoutSliderController from './setout/slider_controller.js'
application.register('setout--slider', SetoutSliderController)

import SetoutSplicerController from './setout/splicer_controller.js'
application.register('setout--splicer', SetoutSplicerController)

import SetoutPdfFragmentController from './setout_pdf/fragment_controller.js'
application.register('setout-pdf--fragment', SetoutPdfFragmentController)

import SetoutPdfTemplateController from './setout_pdf/template_controller.js'
application.register('setout-pdf--template', SetoutPdfTemplateController)

import ShareController from './share_controller.js'
application.register('share', ShareController)

import SliderController from './slider_controller.js'
application.register('slider', SliderController)

import SlideshowController from './slideshow_controller.js'
application.register('slideshow', SlideshowController)

import TabsController from './tabs_controller.js'
application.register('tabs', TabsController)

import TextEditorController from './text_editor_controller.js'
application.register('text-editor', TextEditorController)

import ThirdPartyDigipixController from './third_party/digipix_controller.js'
application.register('third-party--digipix', ThirdPartyDigipixController)

import TogglerController from './toggler_controller.js'
application.register('toggler', TogglerController)

import VirtualRoomController from './virtual_room_controller.js'
application.register('virtual-room', VirtualRoomController)
